/* TooltipHeader.tsx generated by @compiled/babel-plugin v0.28.8 */
import "./TooltipHeader.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { element } from '../../../core/elements/create';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const headerCss = null;
function TooltipHeader(_ref) {
  let {
    children,
    hide,
    datum
  } = _ref;
  if (hide) return null;
  return /*#__PURE__*/_jsx("div", {
    className: ax(["_1wpz1fhb _syaz1glm _1wyb1skh _ect41wi2 _k48p1nn1 _slp31hna"]),
    children: children
  });
}
const _TooltipHeader = element(TooltipHeader);
export { _TooltipHeader as TooltipHeader };